{
  "page": {
    "title": "Solicitudes",
    "subtitle": "Regularizaciones de marcas, justificaciones de tardanzas y faltas, y re-vinculaciones de dispositivo.",
    "marksTitle": "Regularizaciones de marcas",
    "marksSubtitle": "Horas que los trabajadores proponen para completar una jornada. Al aprobar se crea una marca manual.",
    "noAccess": "No tienes acceso a ninguna bandeja de solicitudes."
  },
  "tabs": {
    "label": "Tipo de solicitud",
    "marcaciones": "Marcaciones",
    "justificaciones": "Justificaciones",
    "countLabel": "{count} pendientes"
  },
  "filters": {
    "legend": "Filtrar solicitudes",
    "status": "Estado",
    "statusAll": "Todas",
    "site": "Sede",
    "allSites": "Todas las sedes",
    "worker": "Trabajador",
    "allWorkers": "Todos los trabajadores",
    "workerPlaceholder": "Buscar trabajador",
    "fromDay": "Desde",
    "toDay": "Hasta"
  },
  "status": {
    "ASKED": "Pedida",
    "PENDING": "Pendiente",
    "APPROVED": "Aprobada",
    "REJECTED": "Rechazada",
    "CANCELLED": "Cancelada"
  },
  "statusFilter": {
    "ASKED": "Pedidas",
    "PENDING": "Pendientes",
    "APPROVED": "Aprobadas",
    "REJECTED": "Rechazadas",
    "CANCELLED": "Canceladas"
  },
  "missing": {
    "CHECK_IN": "Entrada",
    "CHECK_OUT": "Salida"
  },
  "table": {
    "caption": "Solicitudes de regularización de marcas",
    "worker": "Trabajador",
    "site": "Sede",
    "day": "Día",
    "missing": "Falta",
    "proposed": "Hora propuesta",
    "reason": "Motivo",
    "age": "Hace",
    "status": "Estado",
    "actions": "Acciones",
    "noProposal": "Sin propuesta aún",
    "anonymized": "Trabajador anonimizado",
    "review": "Revisar",
    "view": "Ver",
    "cancelAsk": "Cancelar pedido"
  },
  "empty": {
    "title": "No hay solicitudes pendientes",
    "description": "Cuando un trabajador proponga una hora, aparecerá aquí."
  },
  "error": {
    "title": "No pudimos cargar las solicitudes",
    "notFound": "No encontramos esta solicitud."
  },
  "review": {
    "title": "Revisar regularización",
    "viewTitle": "Solicitud de regularización",
    "description": "{worker} · {site}",
    "timeline": "Línea de tiempo",
    "previous": "Marca anterior",
    "anchor": "Marca registrada",
    "proposal": "Propuesta",
    "next": "Marca siguiente",
    "workerReason": "Motivo del trabajador",
    "askedBy": "Pedida por {name}",
    "askedBySomeone": "Pedida por un administrador",
    "askedNote": "Nota del pedido",
    "waitingWorker": "Esperando a que el trabajador indique la hora.",
    "date": "Fecha",
    "time": "Hora",
    "timeHelp": "Hora de {site} (24 h).",
    "note": "Nota para el trabajador (opcional)",
    "noteHelp": "El trabajador verá esta nota junto a la aprobación.",
    "willCreate": "Se creará una marca manual de {type} a nombre de {worker}, con el motivo que escribió.",
    "gapClosed": "Esta jornada ya no está incompleta: alguien ya corrigió las marcas. Puedes rechazar la solicitud.",
    "approve": "Aprobar",
    "reject": "Rechazar",
    "cancelAsk": "Cancelar pedido",
    "approvedToast": "Solicitud aprobada. Se creó la marca manual.",
    "flagClearedToast": "Se retiró el aviso de salida pendiente.",
    "rejectedToast": "Solicitud rechazada.",
    "cancelledToast": "Pedido cancelado.",
    "resolution": "Resolución",
    "resolvedBy": "Resuelta por",
    "resolvedAt": "Resuelta el",
    "approvedAt": "Hora aprobada",
    "proposedAt": "Hora propuesta",
    "adjusted": "Ajustada por el administrador",
    "adminNote": "Nota para el trabajador",
    "rejectReason": "Motivo del rechazo",
    "cancelledAt": "Cancelada el",
    "cancelledReason": "Causa",
    "viewMark": "Ver marca",
    "unknownAdmin": "Un administrador"
  },
  "cancelReason": {
    "WORKER": "La canceló el trabajador",
    "ADMIN": "La canceló un administrador",
    "MARKS_CHANGED": "Las marcas cambiaron",
    "WORKER_DEACTIVATED": "Trabajador desactivado"
  },
  "reject": {
    "title": "Rechazar la solicitud",
    "description": "El trabajador verá este motivo y podrá proponer otra hora si le quedan intentos.",
    "reason": "Motivo del rechazo",
    "reasonRequired": "El motivo es obligatorio.",
    "confirm": "Rechazar solicitud"
  },
  "ask": {
    "title": "Pedir regularización",
    "confirmation": "Le pediremos a {worker} que indique la hora de {type}.",
    "note": "Nota para el trabajador (opcional)",
    "notePlaceholder": "Ej.: Indícanos a qué hora saliste",
    "submit": "Pedir regularización",
    "askedToast": "Le pedimos a {worker} que regularice su marca."
  },
  "errors": {
    "unavailable": {
      "NO_GAP": "Esta jornada ya no está incompleta: alguien ya corrigió las marcas.",
      "OUTSIDE_WINDOW": "La marca está fuera del plazo para regularizar.",
      "ALREADY_OPEN": "Ya hay una solicitud abierta para esta marca.",
      "PROPOSALS_EXHAUSTED": "El trabajador ya usó todas sus propuestas para esta marca.",
      "WORKER_NOT_ACTIVE": "El trabajador no está activo.",
      "TOO_OLD": "Solo se puede pedir para marcas de los últimos 60 días."
    }
  }
}
